export function toBlob(data: ArrayBuffer) {
  const blob = new Blob([data], {type: 'application/octet-stream'});
  return blob;
}
